var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tableWrapper",staticClass:"table-wrapper prepare hidden"},[_c('table',{ref:"tableHeader",staticClass:"table-header"}),_vm._v(" "),_c('table',{ref:"table",staticClass:"table-body"},[_c('thead',{ref:"thead"},[_vm._t("header")],2),_vm._v(" "),_c('tbody',{ref:"tbody"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ea24040","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/fixed-header-table.vue
// module id = null
// module chunks = 